import Dragger from "antd/lib/upload/Dragger";
import React from "react";
import { InboxOutlined } from "@ant-design/icons";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MultipleUpload from "./MultipleUpload";



const DraggerComp = ({ uploadFile, uploadTemp, handleCancel, toggle, source, imageUrl, openFor, setIsmodal, accept, uploadType, origin }) => {
  const [showInputFileName, setShowInputFileName] = useState(false);
 
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [disabledSaveButton, setSisabledSaveButton] = useState(false);
  const [showViewFileModal, setShowViewFileModal] = useState(false);
  const [fileInfo, setFileInfo] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { PropertyImageDataLoading } = useSelector((state) => state.PropertyReducer);

  function isUrlOrBlob(input) {
    const urlPattern = /^(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]$/i;

    if (urlPattern.test(input)) {
      return "url";
    }

    const base64Pattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*$/;

    if (base64Pattern.test(input)) {
      return "blob";
    }

    return "unknown";
  }


  // Handling PropertyDocs

  function beforeUpload(file) {
    let supportedFormats = file?.type;
   
    const isImage = supportedFormats?.startsWith("image/");
  const isJpgOrPng = supportedFormats === "image/jpeg" || supportedFormats === "image/png" || supportedFormats === "image/jpg" || supportedFormats === "image/webp";
  if ((uploadType === "IMAGE") &&(!isImage || !isJpgOrPng)) {
    message.error("Only image files are allowed.");
   }
    if (supportedFormats?.includes("image")) {

      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg" || file.type === "image/webp"||  file.type === "image/avif";
      
      if (!isJpgOrPng) {
        message.error("You can't only upload this image");
      }
      const isLt5M = file.size / 1024 / 1024 < 100;
      if (!isLt5M) {
        message.error("Image must smaller than 100MB!");
      }
      return isJpgOrPng && isLt5M;
    } else if (supportedFormats?.includes("pdf")) {
      const isPdf = file.type === "application/pdf";
      if (!isPdf) {
        message.error("You can only upload PDF file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        message.error("File must be smaller than 100MB!");
      }
      return isPdf && isLt2M;
    } else {
      message.error("You can upload only image and pdf");
      setShowViewFileModal(false);
      setSelectedFiles([])
      return false
    }
  }
 

  useEffect(() => {
    if (openFor === "EDIT" && imageUrl) {
      setPreviewUrl(imageUrl);
    }

    return () => {
      setPreviewUrl(null);
    };
  }, [imageUrl, openFor]);

  //   for paste event
  useEffect(() => {
    const PasteEventFunction = (event) => {
      // ... all your logic for handling paste

      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      const fileItem = Array.from(items).find((item) => item.kind === "file");

      if (fileItem) {
        const blob = fileItem.getAsFile();
        const ide = Math.floor(10000 + Math.random() * 90000);
        const imageName = "pastedImage" + ide;
        const updatedBlob = new File([blob], imageName, { type: blob.type });
        const fileUrl = URL.createObjectURL(updatedBlob);

        setSelectedFiles((prev) => [...prev, { name: imageName, size: updatedBlob?.size, selected: true, url: fileUrl, type: updatedBlob.type }]);
        setFileInfo((prev) => [...prev, { file: updatedBlob, filename: imageName }]);
        setShowViewFileModal(true);

        setShowInputFileName(true);

        if (setIsmodal) {
          setIsmodal((prev) => ({ ...prev, isImagePasted: true }));
        }
      }
    };

    const getModal = document.querySelector("#uploaddiv");
    getModal?.addEventListener("paste", PasteEventFunction);

    return () => {
      getModal?.removeEventListener("paste", PasteEventFunction);
    };
  }, [beforeUpload, toggle]);

  const [duplicateUpload, setDuplicateUpload] = useState([]);
  useEffect(() => {
    if (previewUrl === null) {
      setSisabledSaveButton(true);
    } else {
      setSisabledSaveButton(false);
    }

    return () => {
      setSisabledSaveButton(false);
    };
  }, [previewUrl]);

  const handleFileUploadChange = (info) => {
    const rawFiles = info.fileList.map((f) => f.originFileObj);

    const validFiles = rawFiles.filter((f) => {
      const isImage = f?.type?.startsWith("image/");
      const isPdf = f?.type === "application/pdf";
  
      if (uploadType === "IMAGE") {
        return isImage;
      }
  
      // Default: allow image and PDF
      return isImage || isPdf;
    });
  
  
    if (validFiles.length === 0) return;
  
    setSelectedFiles(
      validFiles.map((f) => ({
        name: f.name,
        size: f.size,
        selected: true,
        url: URL.createObjectURL(f),
        type: f.type,
      }))
    );
  
    setFileInfo(
      validFiles.map((f) => ({
        file: f,
        filename: f.name,
      }))
    );
  
    setShowViewFileModal(true);
  };
  


  return (
    <>
      <div id="uploaddiv">
      
        <div style={{ display: loading || previewUrl ? "none" : "flex" }}>
          {selectedFiles.length <= 0 ? (
            <div style={{ display: loading || previewUrl ? "none" : "flex" }}>
              <Dragger
                progress={false}
                style={{ width: "400px" }}
                // accept={uploadType === "IMAGE" ? ".png,.jpg,.jpeg,.webp" : ".png,.jpg,.jpeg,.webp,.pdf"}
                showUploadList={false}
                onChange={handleFileUploadChange}
                onCancel={() => {
                  setSelectedFiles([]);
                }}
                beforeUpload={beforeUpload}
                multiple={source !== "EMAIL_SIGN" && true}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <>
                  <p className="ant-upload-text">Paste, Click or drag file to this area to upload</p>
                  {source === "EMAIL_SIGN" ? <p className="ant-upload-hint">The recommended aspect ratio for the image is 600x300 pixels.</p> : <p className="ant-upload-hint">Support for Multiple Image upload. Strictly prohibit from uploading company data or other band files</p>}
                </>
              </Dragger>
            </div>
          ) : (
          <MultipleUpload files={selectedFiles} uploadFile={uploadFile} showViewFileModal={showViewFileModal} setShowViewFileModal={setShowViewFileModal} loading={loading} setLoading={setLoading} fileInfo={fileInfo} setSelectedFiles={setSelectedFiles} setFileInfo={setFileInfo} setDuplicateUpload={setDuplicateUpload} duplicateUpload={duplicateUpload} uploadTemp={uploadTemp} uploadType={uploadType} showInputFileName={showInputFileName} origin={origin} />
          )}
        </div>
     
       
{/*       
        {toggle ? (
          <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginTop: "20px" }}>
            <div>
              <div
                style={{
                  width: "10%",
                  margin: "auto",
                  display: loading ? "flex" : "none",
                }}
              >
                <LoadingOutlined
                  style={{
                    fontSize: 64,
                  }}
                  spin
                />
              </div>

              <div
                style={{
                  display: previewUrl ? "flex" : "none",
                  width: "40%",
                  margin: "auto",
                }}
              >
                {previewUrl && (
                  <Image
                    src={isUrlOrBlob(previewUrl) === "url" ? previewUrl : `data:image/png;base64,${previewUrl}`}
                    loading="lazy"
                    preview={{
                      visible: false,
                      mask: (
                        <div
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            zIndex: 21,
                            top: "0px",
                            right: "0px",
                          }}
                        >
                          <div
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                          >
                            <Popconfirm
                              title="Are you sure you want to delete this image?"
                              onConfirm={() => {
                                deleteImg();
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <CloseCircleOutlined style={{ fontSize: "30px" }} />
                            </Popconfirm>
                          </div>
                        </div>
                      ),
                    }}
                  />
                )}
              </div>
            </div>

            {fileText?.name && (
              <div>
                <div style={{ textAlign: "center" }}>
                  <Typography.Text type="secondary">
                    <strong>File Name:</strong> {fileText.name}
                  </Typography.Text>
                  <br />
                  <Typography.Text type="secondary">
                    <strong>Size:</strong> {fileText.size}
                  </Typography.Text>
                </div>
              </div>
            )}
            {source !== "EMAIL_SIGN" && (
              <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }} wrapperCol={{ offset: 10, span: 14 }}>
                <Button disabled={disabledSaveButton} loading={PropertyImageDataLoading} type="primary" htmlType="submit" style={{ marginRight: "15px", marginLeft: "-20px" }} onClick={handleUploadFunc}>
                  Done
                </Button>
                <Button type="primary" onClick={handleCancelInputFileName}>
                  Cancel
                </Button>
              </div>
            )}
          </div>
        ) : null} */}
      </div>
    </>
  );
};

export { DraggerComp };
